import { render, staticRenderFns } from "./ArchiveProject.vue?vue&type=template&id=2cb66836"
import script from "./ArchiveProject.vue?vue&type=script&lang=js"
export * from "./ArchiveProject.vue?vue&type=script&lang=js"
import style0 from "./ArchiveProject.vue?vue&type=style&index=0&id=2cb66836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports